export default __webpack_public_path__ + "static/floppylogo-0c07fbe46fbceda7efdfb169dd4ef14a.png";